import React, { useState } from "react";
import moment from "moment";
import TextInputField from "../../../Shared/TextInputField";
import Button from "../../../Shared/Button";
import { fetchDailyBookedReport } from "../../../../services/report";
import * as csv from "fast-csv";
import useReportData from "../useReportData";

const COLUMNS_NAMING_MAP = {
  date: "Date",
  category: "Category",
  URN: "URN",
  patientName: "Patient Name",
  patientDOB: "DOB",
  specialist: "Specialist",
  speciality: "Speciality",
  newAppointmentStartDate: "New Appt Start Date",
  newAppointmentStartTime: "New Appt Start Time",
  originAppointmentStartDate: "Origin Appt Start Date",
  originAppointmentStartTime: "Origin Appt Start Time",
  appointmentLength: "Appointment Length(mins)",
  location: "Location",
  newOrReview: "New/Review",
  appointmentNotes: "Appointment Notes",
};

const DailyBookedReport = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const validationError =
    startDate && endDate && startDate > endDate ? "The start date can not be date after end date!" : "";
  const isReady = Boolean(startDate) && Boolean(endDate) && !validationError;

  const { isLoading, failureReason, info, isEmpty, scheduleLoad, loadNow, download } = useReportData({
    cacheKey: `${startDate}~${endDate}`,
    isReady,
    fileName: `DAILY BOOKED REPORT_${startDate}_${endDate}.csv`,
    infoMessage: `Preparing daily booked report(${startDate} - ${endDate})...`,
    emptyMessage: "No available bookings in given date range",
    loadCsv: async () => {
      const { data: reportRawData } = await fetchDailyBookedReport({ startDate, endDate });
      if (!reportRawData?.length) {
        return { rowCount: 0 };
      }
      // Read every row through the first row's keys so that a row missing a
      // field cannot shift the remaining values into the wrong columns.
      const columnKeys = Object.keys(reportRawData[0]);
      const rows = [columnKeys.map((key) => COLUMNS_NAMING_MAP[key] || key)].concat(
        reportRawData.map((row) =>
          columnKeys.map((key) => (row[key] === null || row[key] === undefined ? "" : String(row[key])))
        )
      );
      return { csv: await csv.writeToString(rows), rowCount: reportRawData.length };
    },
  });

  return (
    <>
      <p className="menu-label">Daily Booked Report</p>
      <div className="columns">
        <div className="column is-one-quarter">
          <TextInputField
            label="Start date"
            isRequired={true}
            hasError={false}
            value={startDate}
            onChange={(e) => {
              setStartDate(e.target.value);
              scheduleLoad();
            }}
            onBlur={loadNow}
            placeholder={moment().format("YYYY-MM-DD")}
            type="date"
          />
        </div>
        <div className="column is-one-quarter">
          <TextInputField
            label="End date"
            isRequired={true}
            hasError={false}
            value={endDate}
            onChange={(e) => {
              setEndDate(e.target.value);
              scheduleLoad();
            }}
            onBlur={loadNow}
            placeholder={moment().format("YYYY-MM-DD")}
            type="date"
          />
        </div>
      </div>
      <p className="has-text-danger is-size-7">{validationError || failureReason}</p>
      <p className="has-text-info is-size-7">{info}</p>
      <Button
        isFullWidth={false}
        disabled={!isReady || isLoading || isEmpty}
        isLoading={isLoading}
        onClick={download}
        text="Download"
      />
    </>
  );
};

export default DailyBookedReport;
